module.exports = __webpack_public_path__ + "img/guardan.350120b9.svg";